import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import React, { useState } from "react";
import ReactSVG from "react-svg";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button } from "@components/atoms";
import { TextField } from "@components/molecules";
import { useDelivery } from "@saleor/sdk/";

var closeWhite = require("../../images/closewhite.svg"); // const greaterThanEqual = require("../../images/greaterThanEqual.svg");


export var AlertObservation = function AlertObservation(_ref) {
  var orderId = _ref.orderId,
      setLoading = _ref.setLoading,
      hideModal = _ref.hideModal;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      reason = _useState2[0],
      setReason = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      errors = _useState4[0],
      SetErrors = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      description = _useState6[0],
      setDescription = _useState6[1];

  var intl = useIntl();

  var _useDelivery = useDelivery(),
      updateToUndelivered = _useDelivery.updateToUndelivered;

  var navigate = useNavigate();

  var handleUpdateToUndelivered = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(reason) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);

              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(position) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            handleMutationUpdateToUndelivered(reason, position);

                          case 1:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }(), function (error) {
                  switch (error.code) {
                    case error.PERMISSION_DENIED:
                      handleMutationUpdateToUndelivered(reason, undefined, "PERMISSION_DENIED");
                      break;

                    case error.POSITION_UNAVAILABLE:
                      handleMutationUpdateToUndelivered(reason, undefined, "POSITION_UNAVAILABLE");
                      break;

                    case error.TIMEOUT:
                      handleMutationUpdateToUndelivered(reason, undefined, "TIMEOUT");
                      break;

                    default:
                      handleMutationUpdateToUndelivered(reason, undefined, "ERROR_UNKNOWN");
                  }
                }, {
                  enableHighAccuracy: true,
                  timeout: 7000
                });
              } else {
                handleMutationUpdateToUndelivered(reason, undefined, "ERROR_UNKNOWN");
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUpdateToUndelivered(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleMutationUpdateToUndelivered = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(reason, position, reasonNoLocation) {
      var _position$coords, _position$coords2, _position$coords3;

      var _yield$updateToUndeli, dataError, errors;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);
              _context3.next = 3;
              return updateToUndelivered(orderId, reason.trim(), (position === null || position === void 0 ? void 0 : (_position$coords = position.coords) === null || _position$coords === void 0 ? void 0 : _position$coords.latitude) ? Number(position.coords.latitude.toFixed(5)) : null, (position === null || position === void 0 ? void 0 : (_position$coords2 = position.coords) === null || _position$coords2 === void 0 ? void 0 : _position$coords2.longitude) ? Number(position.coords.longitude.toFixed(5)) : null, (position === null || position === void 0 ? void 0 : (_position$coords3 = position.coords) === null || _position$coords3 === void 0 ? void 0 : _position$coords3.accuracy) ? Number(position.coords.accuracy.toFixed(5)) : null, reasonNoLocation || null);

            case 3:
              _yield$updateToUndeli = _context3.sent;
              dataError = _yield$updateToUndeli.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                setLoading(false);
                SetErrors(errors);
              } else {
                hideModal();
                setLoading(false);
                navigate("/delivery");
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleMutationUpdateToUndelivered(_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  var saveWrittenReason = function saveWrittenReason() {
    if (reason.trim().length >= 10) {
      handleUpdateToUndelivered(reason.trim());
    } else {
      setDescription(true);
    }
  };

  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "showContainerDeliveryWritten"
  }), React.createElement("div", {
    className: "showContainerDeliveryWritten__data"
  }, React.createElement("div", {
    className: "showContainerDeliveryWritten__data__close"
  }, React.createElement("p", null, React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryWritten.index.3853742296",
    defaultMessage: "Undelivered"
  })), React.createElement(ReactSVG, {
    path: closeWhite,
    onClick: hideModal
  })), React.createElement("div", {
    className: "showContainerDeliveryWritten__data__content showContainerDeliveryWritten__data__content--first"
  }), React.createElement("div", {
    className: "showContainerDeliveryWritten__data__content  showContainerDeliveryWritten__data__content--amount showContainerDeliveryWritten__data__content--first showContainerDeliveryWritten__data__content--last"
  }, React.createElement(TextField, {
    name: "undelivered_reason",
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Reason",
      "id": "components.AlertDeliveryWritten.index.3077186403"
    }, "id", "components.AlertDeliveryWritten.index.3077186403")),
    value: reason,
    onChange: function onChange(e) {
      if (e.target.value.length <= 140) {
        setReason(e.target.value);
        setDescription(false);
      }
    },
    autoComplete: "undelivered_reason",
    textAreaInputLabel: true,
    placeholder: intl.formatMessage(_defineProperty({
      defaultMessage: "Ex: The address is incorrect",
      "id": "components.AlertDeliveryWritten.index.2938220845"
    }, "id", "components.AlertDeliveryWritten.index.2938220845"))
  }), description && React.createElement("p", null, "El motivo debe ser m\xE1s extenso"), errors && React.createElement("div", {
    className: "showContainerDeliveryWritten__data__content"
  }, React.createElement("p", null, errors[0].message))), React.createElement("div", {
    className: "showContainerDeliveryWritten__data__footer"
  }, React.createElement(Button, {
    type: "button",
    testingContext: "",
    onClick: saveWrittenReason
  }, React.createElement(FormattedMessage, {
    id: "components.AlertDeliveryWritten.index.2828880379",
    defaultMessage: "Confirm"
  })))));
};
export default AlertObservation;